<template>
  {{ trans(`aspects.${aspect}.common.` + (value ? 'yes' : 'no')) }}
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
  },
  setup() {
    return {};
  },
};
</script>
